import React from 'react'

const ReportCallDetailHead = () => {
    return (
        <thead className="CustomersHead">
        <tr>
            <th>Tên khách hàng</th>
            <th>Ngày phát sinh</th>
            <th>Hotline</th>
            <th>Số đích</th>
            <th>Số hiển thị</th>
            <th>Thời gian đổ chuông</th>
            <th>Call_id (nếu có)</th>
        </tr>
        </thead>
    )
}

export default ReportCallDetailHead
